<div class="shop-billing-page">
    <!-- Loading State -->
    <div *ngIf="loading" class="loading-state">
        <div class="loader"></div>
        <p>Loading package details...</p>
    </div>

    <!-- Error State -->
    <div *ngIf="!loading && error" class="error-state">
        <span class="error-icon">⚠️</span>
        <h3>Unable to load package</h3>
        <p>The package details could not be fetched. Please go back and try again.</p>
        <button (click)="goBack()" class="back-btn-styled">Back to Shop</button>
    </div>

    <!-- Billing Content -->
    <div *ngIf="!loading && !error && orderSummary">
        <div class="page-header">
            <button class="back-link" (click)="goBack()">
                <i class="pi pi-arrow-left"></i> Back to Shop
            </button>
            <h2 class="page-title">Complete Your Purchase</h2>
        </div>
        <app-billing [orderSummary]="orderSummary"></app-billing>
    </div>
</div>